module.exports = __webpack_public_path__ + "img/logo.446dc72a.png";